
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/external-partners",
      function () {
        return require("private-next-pages/solutions/external-partners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/external-partners"])
      });
    }
  